import vue from 'vue';

//import toast from './vue-easy-toast';
import elementPlugnins from './element-plugnins'; //全局引入 需要用的饿了么插件
import extended from './extended'; //全局引入 需要用的饿了么插件

//vue.use(toast);
vue.use(elementPlugnins);
vue.use(extended);



// WEBPACK FOOTER //
// ./src/plugins/index.js